export default "__VITE_ASSET__Bw$cUR0n__"